import React, { useEffect, useState } from "react";

/**
 * Reusable countdown timer component
 * Displays MM:SS format with real-time updates
 */
const GameCountdown = ({ endsAt, onExpiry = null }) => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!endsAt) return;

    const updateCountdown = () => {
      const now = Date.now();
      const endTime =
        endsAt.toDate ? endsAt.toDate().getTime() : endsAt.getTime();
      const diff = endTime - now;

      if (diff <= 0) {
        setTimeLeft(0);
        if (onExpiry) {
          onExpiry();
        }
      } else {
        setTimeLeft(Math.floor(diff / 1000)); // Convert to seconds
      }
    };

    // Update immediately
    updateCountdown();

    // Update every second
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [endsAt, onExpiry]);

  if (timeLeft === null) {
    return null;
  }

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="text-white text-4xl font-bold tabular-nums">
      {minutes}:{seconds.toString().padStart(2, "0")}
    </div>
  );
};

export default GameCountdown;
